export function stringFromUnknown(value) {
    return String(value);
}
export function formatString(value) {
    return value;
}
